<template>
  <Loading v-if="globalLoading" :full-screen="true" text="Carregando..." size="lg" color="primary" />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useLoadingStore } from '../stores/loading.ts'
import Loading from './ui/Loading.vue'

const loadingStore = useLoadingStore()
const { globalLoading } = storeToRefs(loadingStore)
</script>
